import NewSubAccountPopup from '@/subaccount/NewSubAccountPopup.vue'
import {SubAccountCreatable} from '@/assignments/SubAccountCreatable/SubAccountCreatable.type'
import useDynamicComponentLoader from '@/dynamic-component-loader/dynamicComponent.service'
import {Assignment} from '@/assignments/Assignment.type'
import {assignmentToFulfillment} from '@/assignments/assignment.service'
import {nextTick} from 'vue'

const { loadComponent } = useDynamicComponentLoader()

export const handleSubAccountCreatable = (
    subAccountCreatable: SubAccountCreatable,
    assignment: Assignment,
    panelId: number | undefined,
) => {
    loadComponent(NewSubAccountPopup, {
        relationType: subAccountCreatable.relationType,
        name: subAccountCreatable.name,
        orgNo: subAccountCreatable.orgNo,
        contactInfo: subAccountCreatable.contactInfo,
        address: subAccountCreatable.address,
        fulfillment: assignmentToFulfillment(assignment),
        panelId: panelId
    }, {
        close: () => nextTick(focus)
    })
}